
import { vulnIdFormat, mapSeverityToClassName, openLink } from "../../classes/utils"
import "../../styles/selectedScanTable.css"
export default function ({ mappedSelectedScan }) {
    return <div className="">
        <div className="scan-table  min-h-[435px] max-h-[435px] overflow-auto">
            <table className="table-auto">
                <thead className="">
                    <tr className="">
                        <th className="th-vuln-id sticky-header">
                            <h1 className="vuln-id-long-name">Vulnerability ID</h1>
                            <h1 className="hidden vuln-id-short-name">Vuln ID</h1>
                        </th>
                        <th className="th-vuln-severity sticky-header"> Severity</th>
                        <th className="th-vuln-days-to-fix sticky-header">Days to fix</th>
                        <th className="th-vuln-fixed-by sticky-header">Fixed by</th>
                    </tr>
                </thead>
                <tbody className="max-h-[400px] overflow-y-auto">
                    {mappedSelectedScan.vulnsFixed.map((vuln, i) => {
                        return <tr key={`${i}-${vuln.id}`} className="cursor-pointer" onClick={() => openLink(`/vulns?id=${vuln.adviceID}&mode=eli`)}>
                            <td className="text-start truncate">{vulnIdFormat(vuln.id)}</td>
                            <td><h1 className={`p-1 border-2 w-18 rounded-md ${mapSeverityToClassName(vuln.severity, "vuln")}`}>{vuln.severity.toUpperCase()}</h1></td>
                            <td>{vuln.daysToFix}</td>
                            <td>{vuln.fixedBy}</td>
                        </tr>
                    })}
                    {!mappedSelectedScan.mitigationCount && <tr><td className="" colSpan={4}>no mitigations</td></tr>}
                </tbody>
            </table>
        </div>
    </div>
}